
export enum Path {
  Home = '/',
  Home2 = '/home',
  About = '/about',
  //ContactUs = '/contact',

  Login = '/login',
  UserDashboard = '/user/dashboard',





 

}
